import { create } from 'zustand'

import { createJSONStorage, persist } from 'zustand/middleware'
import { persistStorage } from '@/shared/state/dataBase/persistStorage'
import { ChannelDataType, ChannelType } from '@/shared/types/appTypes'

export interface TvState {
    isStoreHydrated: boolean
    selectedChannel: ChannelDataType | null
    channelsData: ChannelType[]
    whatNextId: string
    isPIPMode: boolean
    displayNextButton: boolean
    favoriteChannels: string[]

    setIsStoreHydrated: () => void
    setSelectedChannel: (channel: ChannelDataType | null) => void
    setWhatNextId: (channelId: string) => void
    setChannelsData: (channelsList: ChannelType[]) => void
    setIsPIPMode: (value: boolean) => void
    setDisplayNextButton: (value: boolean) => void
    setFavoriteChannels: (favChannels: string[]) => void
    clearTvStore: () => void
}

export const useTVStore = create<TvState>()(
    persist(
        (set) => ({
            isStoreHydrated: false,
            selectedChannel: null,
            channelsData: [],
            whatNextId: '',
            isPIPMode: false,
            displayNextButton: false,
            favoriteChannels: [],

            setIsStoreHydrated: () => {
                set(() => ({
                    isStoreHydrated: true,
                }))
            },
            setSelectedChannel: (channel: ChannelDataType | null) => {
                set(() => ({
                    selectedChannel: channel,
                }))
            },
            setWhatNextId: (channelId: string) => {
                set(() => ({
                    whatNextId: channelId,
                }))
            },
            setChannelsData: (channelsList: ChannelType[]) =>
                set({ channelsData: channelsList }),
            setIsPIPMode: (value: boolean) => set(() => ({ isPIPMode: value })),
            setDisplayNextButton: (value: boolean) =>
                set(() => ({ displayNextButton: value })),
            setFavoriteChannels: (favChannels: string[]) =>
                set(() => ({ favoriteChannels: favChannels })),
            clearTvStore: () =>
                set(() => ({
                    channelsData: [],
                    favoriteChannels: [],
                    displayNextButton: false,
                    isPIPMode: false,
                    whatNextId: '',
                    selectedChannel: null,
                })),
        }),

        {
            name: 'tv-storage',
            storage: createJSONStorage(() => persistStorage),
            onRehydrateStorage: (state) => {
                if (state) state.setIsStoreHydrated()
            },
        }
    )
)
